import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import withStyles from 'isomorphic-style-loader/withStyles';

import SiteSettingsForm from '../../../components/siteadmin/SiteSettingsForm';
import Loader from '../../../components/Loader';
import { withQuery } from '../../../hoc/withGraphql';

import s from './SiteSettings.css';

const SiteSettings = (props) => {

  const { data: { loading, siteSettings }, title } = props;
  let settingsCollection = {};
  !loading && siteSettings?.map((item, key) => {
    settingsCollection[item.name] = item.value;
  });

  if (loading) {
    return <Loader type={"text"} />;
  } else {
    return settingsCollection && !loading && <SiteSettingsForm initialValues={settingsCollection} />
  }
}

SiteSettings.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    siteSettings: PropTypes.array,
  })
};

SiteSettings.defaultProps = {
  data: {
    loading: true
  }
};

export default compose(
  withStyles(s),
  withQuery(gql`
        {
          siteSettings {
            name
            value
          }
        }
      `,
    {
      options: (props) => ({
        fetchPolicy: 'network-only',
        ssr: false,
      })
    }
  ),
)(SiteSettings);
